<div class="page-header-left" *ngIf="!isSimpleMode || (isSimpleMode && isInitializePage)">
    <a class="logo" [class.simple-logo]="isSimpleMode && isInitializePage"
        [class.clickable]="this.isNotLoginPage && !this.isInitializePage && !this.isPoweronFailPage && logoClick"
        (click)="logoClick()"
        [class.login-page]="!isNotLoginPage">
        <svg *ngIf="!logoUrl">
            <use [attr.xlink:href]="isSimpleMode && isInitializePage ? '#app-icon-logo-black' : '#app-icon-logo'"></use>
        </svg>
        <img *ngIf="logoUrl" [attr.src]="logoUrl" alt="logo">
    </a>
    <div class="product-info">
        <span class="product-name">DeviceManager</span>
        <ng-container *ngIf="!isSimpleMode">
            <span class="device-separator" *ngIf="deviceNameObj && deviceNameObj.str"></span>
            <a [class]="!SWITCH.IS_VSTORE_SYSTEM ? 'device-name' : 'vstoreSystem-name'"
                *ngIf="deviceNameObj && deviceNameObj.str"
                [nTooltip]="deviceNameObj.showEllipsis ? deviceNameObj.realStr : null"
                (click)="jumpToDeviceSetting()">
                {{deviceNameObj.str}}
            </a>
        </ng-container>
    </div>
</div>
<div class="page-header-center" *ngIf="!isSimpleMode">
    <n-menu *ngIf="isNotLoginPage && !isInitializePage && isLogined && !isPoweronFailPage"
        [menus]="menus"
        (displayMenusChange)="displayMenusChange($event)">
    </n-menu>
</div>
<div class="page-header-right">
    <!-- 这里添加新的操作按钮时，可能导致中部菜单自动换行，请做好自验证 -->
    <ng-container *ngIf="isNotLoginPage && !isInitializePage && isLogined && !isPoweronFailPage">
        <app-smartgui-switch class="operate-item"
            [class.un-operate]="!hasGuiWritePermission"
            *ngIf="SWITCH.SUPPORT_SMART_GUI
                && !SWITCH.IS_VSTORE_SYSTEM
                && !SWITCH.IS_DIRECT_MODE
                && hasGuiReadPermission
                && !isSimpleMode
                && SWITCH.PRODUCT_SUPPORT_AI">
        </app-smartgui-switch>
        <!-- 全局搜索 -->
        <app-global-search *ngIf="!SWITCH.IS_VSTORE_SYSTEM && !isSimpleMode"></app-global-search>
        <!-- 极简/标准模式切换按钮 -->
        <app-simple-mode-switch class="operate-item" *ngIf="supportSimpleMode" [hasLunLicense]="hasLunLicense"></app-simple-mode-switch>
        <!-- 告警 -->
        <app-alarm-panel class="operate-item" *ngIf="checkShow(['alarm_R']) && !SWITCH.IS_VSTORE_SYSTEM"></app-alarm-panel>
        <!-- 波动检测 -->
        <app-anomaly-panel class="operate-item" *ngIf="!isSimpleMode && showAnomalyIcon && checkShow(['performance_R'])"></app-anomaly-panel>
        <!-- 最近任务 -->
        <app-task-panel class="operate-item" *ngIf="checkShow | fn :['task_R']"></app-task-panel>
        <!-- 升级 -->
        <app-upgrade #upgrade></app-upgrade>
        <app-system-upgrade #systemUpgrade></app-system-upgrade>
        <app-ota-upgrade #otaUpgrade></app-ota-upgrade>
        <!-- 设置齿轮（里面有设备信息、重启设备、下电设备等） -->
        <app-header-settings *ngIf="!SWITCH.IS_VSTORE_SYSTEM"
            class="operate-item"
            [class.hidden]="!showSettings || isSmallSize || isSimpleMode"
            [upgrade]="upgrade"
            [systemUpgrade]="systemUpgrade"
            [otaUpgrade]="otaUpgrade"
            [enableUpgradeEntry]="true"
            (destroy)="showSettings = false;">
        </app-header-settings>
        <app-header-common-task class="operate-item"
            (destroy)="showComonTask = false;"
            *ngIf="showComonTask && isAdvance && !isSmallSize && !isSimpleMode">
        </app-header-common-task>
    </ng-container>
    <!-- 语言切换 -->
    <div *ngIf="!SUPPORT_JA_LAN && (!isNotLoginPage || isInitializePage || isPoweronFailPage || !isSmallSize || isSimpleMode)"
        class="operate-item"
        (click)="changeLan()">
        <span *ngIf="!isSimpleMode">{{language}}</span>
        <svg *ngIf="isSimpleMode" class="icon language-icon" [nTooltip]="language" nTooltipPlacement="bottom">
            <use [attr.xlink:href]="isLanguageZh ? '#app-icon-language-en' : '#app-icon-language-zh'"></use>
        </svg>
    </div>
    <ng-container *ngIf="SUPPORT_JA_LAN && (!isNotLoginPage || isInitializePage || isPoweronFailPage || !isSmallSize || isSimpleMode)">
        <app-header-language [isSimpleMode]="isSimpleMode"></app-header-language>
    </ng-container>
    <!-- 用户注销 -->
    <div class="user-box"
        *ngIf="isNotLoginPage && isLogined && !isRemoteAssistanceUser"
        [nTooltip]="userDropdown"
        nTooltipOverlayClass="header-tip-user"
        nTooltipPlacement="bottom"
        nTooltipTrigger="click"
        nTooltipTheme="black"
        [(nTooltipVisible)]="userTooltipVisible">
        <div class="user-box" [nTooltip]="isSimpleMode ? userTip : null" nTooltipPlacement="bottom">
            <svg class="icon header-icon">
                <use xlink:href="#app-icon-user-simple"></use>
            </svg>
            <span nTitle>{{userName}}</span>
        </div>
    </div>
    <!-- 帮助和技术支持 -->
    <app-help-memu class="operate-item"
        *ngIf="isNotLoginPage && !isInitializePage && !isPoweronFailPage && (!isSmallSize || isSimpleMode)">
    </app-help-memu>
    <!-- 小屏展示的下拉箭头，里面有语言、设置、帮助 -->
    <div *ngIf="isNotLoginPage && !isInitializePage && isLogined && !isPoweronFailPage && isSmallSize && !isSimpleMode"
        class="more-menu"
        [nTooltip]="moreMenu"
        [nTooltipTrigger]="'click'"
        [nTooltipPlacement]="'bottomRight'"
        [nTooltipTheme]="'black'"
        [nTooltipOverlayClass]="'more-menu-overlay'"
        [(nTooltipVisible)]="moreMenuVisible">
        <svg class="icon">
            <use xlink:href="#icon-arrow-sm-left"></use>
        </svg>
    </div>
    <!-- 极简模式-智能助手 -->
    <app-smart-assistant-switch class="operate-item" [canClick]="true" [tooltip]="smartAssistantTooltip"
        id="smart-assistant-switch"
        *ngIf="isSimpleMode
            && isNotLoginPage
            && !isInitializePage
            && isLogined
            && !isPoweronFailPage
            && hasSmartAssistantWrite">
    </app-smart-assistant-switch>
</div>

<!-- 用户下拉列表 -->
<ng-template #userDropdown>
    <div class="header-tip-box">
        <ul>
            <li (click)="onLogout()">{{logoutText}}</li>
        </ul>
    </div>
</ng-template>

<!-- DME IQ弹出框-->
<n-dialog *ngIf="eServiceOpen"
    class="eService-box"
    [visible]="true"
    (onClose)="eServiceOpen = false">
    <h2 class="eService-title">{{eService}}</h2>
    {{eServiceContentTip}}
    <a [href]="selfService"
        target="_blank">
        {{learnMoreTip}}
    </a>
    <ng-template nTemplate="footer">
        <button nButton
            [label]="configNowTip"
            (click)="openEservice()">
        </button>
    </ng-template>
</n-dialog>

<ng-template #moreMenu>
    <div class="header-tip-box">
        <ul>
            <li *ngIf="!SUPPORT_JA_LAN" (click)="changeLan()">{{language}}</li>
            <li *ngIf="SUPPORT_JA_LAN">
                <app-header-language
                    [isSimpleMode]="isSimpleMode"
                    [isSmallSize]="true"
                ></app-header-language>
            </li>
            <li>
                <app-header-settings class="operate-item"
                    [upgrade]="upgrade"
                    [systemUpgrade]="systemUpgrade"
                    [otaUpgrade]="otaUpgrade"
                    [isSmallSize]="true"
                    (onHidePanel)="moreMenuVisible = false;">
                </app-header-settings>
            </li>
            <li *ngIf="showComonTask && isAdvance">
                <app-header-common-task *ngIf="isAdvance"
                    [isSmallSize]="true"
                    class="operate-item"
                    (onHidePanel)="moreMenuVisible = false;">
                </app-header-common-task>
            </li>
            <li>
                <app-help-memu class="operate-item"
                    [isSmallSize]="true"
                    (onHidePanel)="moreMenuVisible = false;">
                </app-help-memu>
            </li>
        </ul>
    </div>
</ng-template>
